import { gql, type MutationHookOptions, useMutation } from "@apollo/client";

interface DataType {
  removeSavedGame: {
    removed: boolean;
  };
}

interface VariablesType {
  gameId: string;
}

const MUTATION = gql`
  mutation RemoveSavedGame($gameId: ID!) {
    removeSavedGame(gameId: $gameId) {
      removed
    }
  }
`;

export default function useRemoveSavedGameMutation(
  props?: MutationHookOptions<DataType, VariablesType>
) {
  return useMutation<DataType, VariablesType>(MUTATION, props);
}
